import { render, staticRenderFns } from "./AppCreateCompany.vue?vue&type=template&id=d77bc0c2"
import script from "./AppCreateCompany.vue?vue&type=script&lang=js"
export * from "./AppCreateCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports